import React from 'react'

import {
  ERewardHistoryType,
  TRewardHistoryData,
} from '@/libs/apis/queries/use-get-list-reward-history-query'

type TRewardDestinationProps = {
  history: TRewardHistoryData
}

const rewardDestinationLabel = {
  [ERewardHistoryType.CASH]: 'To Rewards',
  [ERewardHistoryType.BANK_WITHDRAWAL]: 'To Bank Account',
  [ERewardHistoryType.EWALLET_WITHDRAWAL]: 'To E-Wallet Account',
  [ERewardHistoryType.ADMIN_FEE]: 'Admin Fee',
}

const getRewardDestination = (history: TRewardHistoryData) => {
  const { type, providerName, maskedAccountNumber } = history

  if (type === ERewardHistoryType.ADMIN_FEE) {
    return `${rewardDestinationLabel[ERewardHistoryType.ADMIN_FEE]}${
      providerName && maskedAccountNumber ? ` to ${providerName} ${maskedAccountNumber}` : ''
    }`
  }

  if (providerName && maskedAccountNumber) {
    return `To ${providerName} ${maskedAccountNumber}`
  }

  return rewardDestinationLabel[type]
}

export default function RewardDestination({ history }: Readonly<TRewardDestinationProps>) {
  return (
    <span className='mr-3 line-clamp-2 text-xs font-normal'>{getRewardDestination(history)}</span>
  )
}
